import ReactDOM from 'react-dom/client';
import './index.css';
import '@barracuda/shared/styles/nemo.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from '@barracuda/shared/i18n';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './styles/theme';
import { analyticsApi } from '@barracuda/shared/analytics';
import { sopaliticsApi } from '@barracuda/shared/analytics/sopalitics';
import { logErrorNR } from '@barracuda/shared/utils/log-error-nr';
import { BrowserRouter } from 'react-router-dom';
import { getThumbmarkDeviceId } from '@/utils/thumbmark';

const NEWRELIC_CONFIG = {
  accountID: process.env.REACT_APP_NEWRELIC_ACCOUNT_ID || '',
  agentID: process.env.REACT_APP_WEB_NEWRELIC_AGENT_ID || '',
  applicationID: process.env.REACT_APP_WEB_NEWRELIC_APPLICATION_ID || '',
  licenseKey: process.env.REACT_APP_NEWRELIC_LICENSE_KEY || '',
  trustKey: process.env.REACT_APP_NEWRELIC_TRUST_KEY || ''
};

// Temporary guard for users that has bookmarked englishexpress URLs.
// Its a client side guard in case of the server side redirect misses any URL.
const REDIRECT_SOURCE_PATTERN = /^englishexpress(-[a-z0-9-]+)?\.pearson\.com$/i;

const redirectToPteExpress = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const { hostname, protocol, pathname, search, hash } = window.location;
  const normalizedHost = hostname.toLowerCase();

  if (!REDIRECT_SOURCE_PATTERN.test(normalizedHost)) {
    return;
  }

  const targetHost = normalizedHost.replace(/^englishexpress/, 'pteexpress');
  const destination = `${protocol}//${targetHost}${pathname}${search}${hash}`;

  window.location.replace(destination);
};

redirectToPteExpress();

analyticsApi.init({
  newRelic: {
    config: NEWRELIC_CONFIG,
    metadata: {
      env: process.env.REACT_APP_MODE ?? 'undefined',
      local: process.env.REACT_APP_LOCAL ?? 'undefined',
      userAgent: navigator.userAgent,
      isDesktop: 'false'
    },
    appVersion: APP_VERSION
  }
});

getThumbmarkDeviceId()
  .then((deviceId) => sopaliticsApi.setDeviceIds({ deviceId }))
  .catch((error: unknown) => {
    logErrorNR(error, '[WebBootstrap] Failed to resolve Thumbmark device id', 'warn', console);
  });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <I18nextProvider i18n={i18n} defaultNS='translation'>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
